export const DEFAULT_WIDGET_ICON_HEIGHT = 76
export const DEFAULT_WIDGET_ICON_WIDTH = 76

export const PREVIEW_MESSAGE_WIDTH_PADDING = 40
export const PREVIEW_MESSAGE_HEIGHT_PADDING = 36
